// src/utils/errorHandler.js
import { toast } from "react-toastify";

/**
 * Check if error is a 403 branch-access denial
 * @param {Error} error - axios error object
 * @returns {boolean} - true if error is a 403 with "branch" in message
 */
export const isBranchAccessError = (error) => {
  if (error?.response?.status !== 403) return false;
  const msg = (error.response?.data?.message || "").toLowerCase();
  return msg.includes("branch");
};

/**
 * Handle API errors with appropriate toast notification
 * Branch access errors get longer display time and distinct message
 * @param {Error} error - axios error object
 * @param {string} defaultMsg - fallback message if error has no response
 */
export const handleApiError = (error, defaultMsg = "Something went wrong") => {
  const msg = error?.response?.data?.message || defaultMsg;

  if (isBranchAccessError(error)) {
    // Branch errors: show for 7 seconds (longer duration for important errors)
    toast.error(`🔒 Access Denied: ${msg}`, { autoClose: 7000 });
  } else if (error?.response?.status === 403) {
    // Other 403 errors
    toast.error(`Access Denied: ${msg}`, { autoClose: 5000 });
  } else if (error?.response?.status >= 500) {
    // Server errors
    toast.error(`Server Error: ${msg}`, { autoClose: 5000 });
  } else if (error?.response?.status >= 400) {
    // Other client errors
    toast.error(msg, { autoClose: 4000 });
  } else if (error?.message) {
    // Network or other errors
    toast.error(`Error: ${error.message}`, { autoClose: 4000 });
  } else {
    // Fallback
    toast.error(defaultMsg, { autoClose: 4000 });
  }
};
